<template>
  <v-card
    ripple
    width="100%"
    class="flex-column d-flex"
    @click="$emit('click', $event)"
  >
    <v-card-title>
      <v-row dense>
        <v-col cols="auto" v-if="icon">
          <v-icon x-large>
            {{ icon }}
          </v-icon>
        </v-col>
        <v-col class="text-truncate">
          <span class="text-wrap">{{ title }}</span>
        </v-col>
        <MenuButton :items="menuItems" @click-item="clickItem" />
      </v-row>
    </v-card-title>
    <v-card-text class="flex-column preserve-whitespace">
      <v-row v-for="(item, index) in items" :key="index" dense>
        <v-col v-if="item.label"> {{ item.label }}</v-col>
        <v-col v-if="item.value" >{{ item.value }}</v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<style scoped>
.preserve-whitespace {
  white-space: pre-line;
}
</style>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import MenuButton from '@/components/menu/MenuButton.vue';
import { MenuItemInterface } from '@/domain/interface/intern/MenuItemInterface';
import { LocaleMessage } from 'vue-i18n';

@Component({ components: { MenuButton } })
export default class InfoCard extends Vue {
  @Prop() readonly title: string | LocaleMessage | undefined;
  @Prop() readonly items: object[] | undefined;
  @Prop(Array) readonly menuItems!: MenuItemInterface[];
  @Prop() readonly icon: string | undefined;

  clickItem(item: object) {
    this.$emit('click-item', item);
  }
}
</script>
